import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import {
    SOCIAL_CLIP_PLACEMENT_OPTIONS,
    explorerFilterControlSx,
    type SocialClipPlacementFilter,
} from './utils';

/** Implementación filter for clip sponsors: tagged, overlay, or placement. */
export function ExplorerSocialPlacementSelect({
    value,
    onChange,
}: {
    value: SocialClipPlacementFilter;
    onChange: (value: SocialClipPlacementFilter) => void;
}) {
    const { t } = useTranslation('explorer');
    const selected = value === 'tagged' || value === 'overlay' || value === 'placement' ? value : 'all';
    return (
        <FormControl size="small" sx={explorerFilterControlSx()}>
            <InputLabel>{t('implementation')}</InputLabel>
            <Select
                value={selected}
                label={t('implementation')}
                renderValue={(current) =>
                    current === 'all' ? t('allFeminine') : t(`socialPlacement.${current}`)
                }
                onChange={(event) => onChange(event.target.value as SocialClipPlacementFilter)}
            >
                <MenuItem value="all">{t('allFeminine')}</MenuItem>
                {SOCIAL_CLIP_PLACEMENT_OPTIONS.map((item) => (
                    <MenuItem key={item} value={item}>
                        {t(`socialPlacement.${item}`)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
